import { render, staticRenderFns } from "./zulin-pro-audit.vue?vue&type=template&id=0480586a&scoped=true"
import script from "./zulin-pro-audit.vue?vue&type=script&lang=js"
export * from "./zulin-pro-audit.vue?vue&type=script&lang=js"
import style0 from "./zulin-pro-audit.vue?vue&type=style&index=0&id=0480586a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480586a",
  null
  
)

export default component.exports